import styled, { css, keyframes } from 'styled-components';
import { Refresh } from '../../action/Refresh';

export const rotate = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;

export const AnimatedRefreshIcon = styled(Refresh)<{
  $isAnimating?: boolean;
  isDisabled?: boolean;
  $isAnimationInfinite?: boolean;
}>`
  ${({ $isAnimating, isDisabled, $isAnimationInfinite }) =>
    $isAnimating && !isDisabled
      ? css`
          animation: ${rotate} 0.75s ease-in-out ${$isAnimationInfinite ? ' infinite' : ''};
        `
      : ''};
`;
